// Firestore does not accept an array as a direct child of another array. Advisor
// report tables use rows shaped as [[cell, ...]], so snapshots need a reversible
// storage representation before they cross the Firebase boundary.
const PlummeAdvisorReportStorage = (() => {
  const NESTED_ARRAY_KEY = '__plummeReportArray';

  const encodeValue = (value, insideArray = false) => {
    if (Array.isArray(value)) {
      const items = value.map((entry) => encodeValue(entry, true));
      return insideArray ? { [NESTED_ARRAY_KEY]: items } : items;
    }
    if (value && typeof value === 'object') {
      return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, encodeValue(entry, false)]));
    }
    return value;
  };

  const decodeValue = (value) => {
    if (Array.isArray(value)) return value.map(decodeValue);
    if (value && typeof value === 'object') {
      const keys = Object.keys(value);
      if (keys.length === 1 && keys[0] === NESTED_ARRAY_KEY && Array.isArray(value[NESTED_ARRAY_KEY])) {
        return value[NESTED_ARRAY_KEY].map(decodeValue);
      }
      return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, decodeValue(entry)]));
    }
    return value;
  };

  return { encodeValue, decodeValue };
})();

Object.assign(window, { PlummeAdvisorReportStorage });
